import { render } from "./bs-collapsible.vue?vue&type=template&id=5b9547c8&lang=true"
import script from "./bs-collapsible.vue?vue&type=script&lang=js"
export * from "./bs-collapsible.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__